// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"DropdownMenu_dropdownMenu__3zBaD","menuItem":"DropdownMenu_menuItem__2jjsI","link":"DropdownMenu_link__8mhIJ","button":"DropdownMenu_button__29W8B"};